module.exports = __webpack_public_path__ + "img/symbol_4.412411e7.png";